import type { Right } from '@gozoki/tools'
import type { PermissionTuple } from '~/utils/ability'

/**
 * Module 20 — Suivi des SMS. Un seul écran, une seule ressource : les SMS envoyés (tableau,
 * compteurs, export CSV), dont la relance des non-lus est une action supplémentaire.
 */

export const SMS_SENT_READ: PermissionTuple = ['read', 'sms.sms.sent']
export const SMS_SENT_EXPORT: PermissionTuple = ['export', 'sms.sms.sent']
export const SMS_RESEND: PermissionTuple = ['resend-unread-sms', 'sms.sms.sent']

/**
 * Droit v1 exigé tant que le flag `permission-v2` est OFF (où tous les tuples v2 passent) :
 * l'entrée de menu « Suivi des SMS » est gardée par `rights: ['ADMIN']`.
 */
export const SMS_LEGACY_RIGHTS: Right[] = ['ADMIN']
